const API_ROUTES = Object.freeze({
  USER: "/users/users/",
  INVITE: "/users/invite/",
});

const QUERY_KEYS = Object.freeze({
  USER: "users",
  INVITE: "invite",
})

export { API_ROUTES, QUERY_KEYS };
